import React from 'react';
import { Box, Card, CardMedia, Grid, Typography } from '@mui/material';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby-theme-material-ui';
import styles from './styles/personStyles';

function PersonCard({
  image,
  photo,
  logo,
  fullName,
  company,
  position,
  previousPosition,
  previousPositionLogo,
  content,
  links,
  ...props
}) {
  const [name, surname] = fullName.split(' ');

  const createSotialLogo = (link) => {
    const { source, url } = link;
    switch (source) {
      case 'telegram': {
        return <StaticImage src="./images/telegram.png" alt="gihub-logo" />;
      }
      case 'github': {
        return <StaticImage src="./images/git.png" alt="gihub-logo" />;
      }
      case 'habr': {
        return <StaticImage src="./images/habr.png" alt="habr-logo" />;
      }
    }
  };

  return (
    <Box sx={{ ...styles.card, ...props }}>
      <Box sx={styles.personalInfoBlock}>
        {image ? (
          <GatsbyImage
            style={styles.imageBlock}
            imgStyle={styles.image}
            image={getImage(image)}
            alt={fullName}
            loading="lazy"
          />
        ) : (
          <Card sx={styles.imageBlock}>
            <CardMedia
              component="img"
              sx={styles.image}
              image={photo?.url}
              alt={fullName}
              loading="lazy"
            />
          </Card>
        )}

        <Box sx={styles.personalInfo}>
          <Typography variant="desktopH3" sx={styles.name}>
            {name}
          </Typography>
          <Typography variant="desktopH3" sx={styles.name}>
            {surname}
          </Typography>
          {position && (
            <Typography variant="desktopP3" fontSize={14} mt={1}>
              {position}
            </Typography>
          )}
          {!!logo && (
            <Box sx={styles.companieLogo}>
              <GatsbyImage
                style={{ height: '100%', width: 'auto' }}
                imgStyle={styles.logoImage}
                image={getImage(logo)}
                alt=""
                loading="lazy"
              />
            </Box>
          )}

          {previousPosition && (
            <Grid container xs={10} mt={1}>
              <Grid item alignSelf="center">
                <Typography variant="desktopP3" fontSize="14px" mr={1}>
                  {previousPosition}
                </Typography>
              </Grid>
              {previousPositionLogo && (
                <Grid item xs={5} alignSelf="center">
                  <CardMedia
                    component="img"
                    image={previousPositionLogo.url}
                    alt={previousPosition}
                    loading="lazy"
                  />
                </Grid>
              )}
            </Grid>
          )}
        </Box>
      </Box>
      <Box sx={{ ...styles.opinion, minHeight: links ? '193px' : 'auto' }}>
        <Typography variant="desktopP3" sx={styles.content}>
          {content}
        </Typography>
        {!!links && (
          <Box sx={styles.links}>
            {links.map((item) => (
              <Link
                key={`${photo}-${item.source}`}
                variant={'kitSecondary'}
                to={item.url}
                target="_blank"
                sx={styles.socialLink}
              >
                <Box sx={styles.social}>{createSotialLogo(item)}</Box>
                Спросить про обучение
              </Link>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default PersonCard;
